var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "fill",
    d: "M10.2296 3.49208H14.768C15.392 3.49208 15.9032 2.98088 15.9032 2.35688C15.9032 1.73288 15.392 1.22168 14.768 1.22168H10.2296C9.60559 1.22168 9.09439 1.73288 9.09439 2.35688C9.09439 2.98088 9.60559 3.49208 10.2296 3.49208Z",
    fill: "#ABAEB2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    className: "fill",
    d: "M20.444 2.35913H17.6072C17.6072 3.60713 16.5848 4.62953 15.3368 4.62953H9.6632C8.4152 4.62953 7.3928 3.60713 7.3928 2.35913H4.556C3.6152 2.35913 2.8544 3.11993 2.8544 4.06073V21.1199C2.8544 22.0607 3.6152 22.8215 4.556 22.8215H20.444C21.3848 22.8215 22.1456 22.0607 22.1456 21.1199V4.06073C22.1456 3.60944 21.9663 3.17663 21.6472 2.85752C21.3281 2.53841 20.8953 2.35913 20.444 2.35913ZM7.016 8.03033H17.9864C18.2984 8.03033 18.5528 8.28473 18.5528 8.59673C18.5528 8.90873 18.2984 9.16313 17.9864 9.16313H7.016C6.704 9.16313 6.4496 8.90873 6.4496 8.59673C6.4472 8.28713 6.704 8.03033 7.016 8.03033ZM7.016 12.0023H17.9864C18.2984 12.0023 18.5528 12.2567 18.5528 12.5687C18.5528 12.8807 18.2984 13.1351 17.9864 13.1351H7.016C6.704 13.1351 6.4496 12.8807 6.4496 12.5687C6.4472 12.2591 6.704 12.0023 7.016 12.0023ZM12.5 16.5431C12.5 16.8551 12.2456 17.1095 11.9336 17.1095H7.016C6.704 17.1095 6.4496 16.8551 6.4496 16.5431C6.4496 16.2311 6.704 15.9767 7.016 15.9767H11.9336C12.2456 15.9743 12.5 16.2287 12.5 16.5431ZM18.7424 16.5431C18.7424 16.8551 18.488 17.1095 18.176 17.1095H14.7704C14.4584 17.1095 14.204 16.8551 14.204 16.5431C14.204 16.2311 14.4584 15.9767 14.7704 15.9767H18.176C18.4856 15.9743 18.7424 16.2287 18.7424 16.5431Z",
    fill: "#ABAEB2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.58a104495e1de6d97bb55a2f76b8b188.svg";
export { ForwardRef as ReactComponent };